// ============================================================
// Braval - Edit Lot Page
// ============================================================

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../api';
import { Header } from '../App';
import LotForm from './LotForm';

export default function EditLotPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [lot,       setLot]       = useState(null);
    const [projects,  setProjects]  = useState([]);
    const [loading,   setLoading]   = useState(true);
    const [loadError, setLoadError] = useState(null);
    const [isSaving,  setIsSaving]  = useState(false);
    const [saveError, setSaveError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [lotRes, projectsRes] = await Promise.all([
                    apiFetch(`/api/lots/${id}`),
                    apiFetch('/api/projects'),
                ]);

                if (!lotRes.ok) {
                    const err = await lotRes.json();
                    setLoadError(err.error || 'Failed to load lot.');
                    return;
                }

                const [lotData, projectsData] = await Promise.all([
                    lotRes.json(),
                    projectsRes.json(),
                ]);

                setLot(lotData);
                setProjects(Array.isArray(projectsData) ? projectsData : []);
            } catch {
                setLoadError('Could not reach the API.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleSave = async (formData) => {
        setIsSaving(true);
        setSaveError(null);
        try {
            const res = await apiFetch(`/api/lots/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            if (!res.ok) {
                const err = await res.json();
                setSaveError(err.error || 'Failed to save.');
                return;
            }
            navigate(lot?.project_id ? `/auctions/${lot.project_id}` : '/comps');
        } catch {
            setSaveError('Could not reach the API.');
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm('Delete this lot? This cannot be undone from the app.')) return;
        try {
            const res = await apiFetch(`/api/lots/${id}`, { method: 'DELETE' });
            if (!res.ok) {
                const err = await res.json();
                alert(err.error || 'Failed to delete lot.');
                return;
            }
            navigate(lot?.project_id ? `/auctions/${lot.project_id}` : '/comps');
        } catch {
            alert('Could not reach the API.');
        }
    };

    return (
        <div className="app-layout">
            <Header />
            <main className="lot-form-page">
                {loading && <div className="results-status">Loading...</div>}
                {loadError && <div className="results-status results-error">{loadError}</div>}
                {!loading && !loadError && lot && (
                    <LotForm
                        pageTitle="Edit Lot"
                        initialValues={lot}
                        projects={projects}
                        onSave={handleSave}
                        isSaving={isSaving}
                        saveError={saveError}
                        onDelete={handleDelete}
                        onCancel={() => navigate(lot?.project_id ? `/auctions/${lot.project_id}` : '/auctions')}
                    />
                )}
            </main>
        </div>
    );
}
